export * from './colaborador-detail.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/colaboradores/colaborador-detail/index.ts